import { ShimmerButton, ShimmerThumbnail, ShimmerText, ShimmerSimpleGallery } from "react-shimmer-effects";


const FourGraphLoading = () => {
    return (
      <div className="min-h-[330px] rounded-lg bg-white shadow-lg p-3">
        <div >
        <div className="flex gap-5">
            <div className="grow">
              <ShimmerThumbnail height={40} rounded />
            </div>
            <ShimmerButton />
          </div>
          <ShimmerSimpleGallery className="mb-0" row={2} col={2} imageType={"thumbnail"} imageHeight={100} gap={30} />
          <ShimmerText line={1}/>
        </div>
      </div>
    )
}
  
export default FourGraphLoading